import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`
  background: linear-gradient(to bottom, #ff7c24, #fff);
  font-family: 'Nunito Sans', sans-serif;
  color: #232830;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
`;

const Card = styled.div`
  background-color: #fff;
  border-radius: 24px;
  padding: 40px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
`;

const Emoji = styled.div`
  font-size: 64px;
  margin-bottom: 20px;
  animation: bounce 2s infinite;
  @keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-12px); }
  }
`;

const Title = styled.h1`
  font-size: 24px;
  color: #FF7C24;
  margin-bottom: 12px;
`;

const Subtitle = styled.p`
  font-size: 16px;
  color: #555;
  margin-bottom: 24px;
`;

const BenefitList = styled.ul`
  list-style: none;
  padding: 0;
  text-align: left;
  max-width: 400px;
  margin: 0 auto 24px;
  li {
    font-size: 16px;
    margin-bottom: 10px;
    &:before {
      content: '✨';
      margin-right: 8px;
    }
  }
`;

const ContinueButton = styled.button`
  background-color: #232830;
  color: #fff;
  padding: 14px 28px;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    transform: scale(1.05);
    background-color: #000;
  }
`;

const ThankYou = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/courses");
  };

  return (
    <Container>
      <Card>
        <Emoji>🎉</Emoji>
        <Title>Thank You for Subscribing!</Title>
        <Subtitle>You’ve just unlocked unlimited learning with FinTorro Pro. 🧠💥</Subtitle>
        <BenefitList>
          <li>Learn with AI</li>
          <li>Unlock All Lessons</li>
          <li>Join Challenges & Earn Rewards</li>
          <li>Access Premium Market Insights</li>
        </BenefitList>
        <ContinueButton onClick={handleContinue}>Continue</ContinueButton>
      </Card>
    </Container>
  );
};

export default ThankYou;






// import React, { useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// const ThankYou = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     // Optional: Auto-redirect to dashboard or course in 5 seconds
//     const timer = setTimeout(() => {
//       navigate("/courses");
//     }, 5000);

//     return () => clearTimeout(timer);
//   }, [navigate]);

//   return (
//     <div style={styles.container}>
//       <div style={styles.card}>
//         <div style={styles.emoji}>🎉</div>
//         <h1 style={styles.title}>Thank You for Subscribing!</h1>
//         <p style={styles.subtitle}>
//           You’ve just unlocked unlimited learning with FinTorro Pro. 🧠💥
//         </p>
//         <ul style={styles.benefits}>
//           <li>✓ Learn with AI</li>
//           <li>✓ Unlock All Lessons</li>
//           <li>✓ Join Challenges & Earn Rewards</li>
//           <li>✓ Access Premium Market Insights</li>
//         </ul>
//         <button
//           style={styles.button}
//           onClick={() => navigate("/post-activation-quote")}
//         >
//           Continue
//         </button>
//         <p style={styles.note}>Redirecting you in 5 seconds...</p>
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     backgroundColor: "#000",
//     color: "#fff",
//     minHeight: "100vh",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     fontFamily: "Nunito Sans",
//     padding: "20px",
//   },
//   card: {
//     backgroundColor: "#1c1c1c",
//     borderRadius: "24px",
//     padding: "40px",
//     maxWidth: "500px",
//     width: "100%",
//     textAlign: "center",
//     boxShadow: "0 0 20px rgba(255, 124, 36, 0.3)",
//   },
//   emoji: {
//     fontSize: "48px",
//     marginBottom: "16px",
//   },
//   title: {
//     fontSize: "28px",
//     color: "#FF7C24",
//     marginBottom: "12px",
//   },
//   subtitle: {
//     fontSize: "16px",
//     color: "#ccc",
//     marginBottom: "24px",
//   },
//   benefits: {
//     listStyle: "none",
//     padding: 0,
//     color: "#ffffff",
//     textAlign: "left",
//     marginBottom: "24px",
//     lineHeight: "1.6",
//   },
//   button: {
//     backgroundColor: "#FF7C24",
//     color: "#000",
//     border: "none",
//     padding: "12px 24px",
//     fontSize: "16px",
//     borderRadius: "12px",
//     cursor: "pointer",
//     fontWeight: "bold",
//     transition: "transform 0.2s ease",
//   },
//   note: {
//     fontSize: "12px",
//     marginTop: "16px",
//     color: "#888",
//   },
// };

// export default ThankYou;
